import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default function (i18n) {
  return new Vuetify({
    lang: {
      current: 'de',
      t: (key, ...params) => i18n.t(key, params)
    },
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      default: 'light',
      themes: {
        light: {
          primary: '#26B19F',
          secondary: '#1E2E51',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107'
        }
      }
    }
  });
};
